import TextInput from '../TextInput';

const ClientEditForm = ({ newClientData, setNewClientData }) => {
    return (
        <div>
            <div className="flex items-center mt-4">
                <TextInput
                    id="firstName"
                    label="First Name"
                    className="mr-2"
                    inlineEditable={true}
                    autoFocus={!newClientData.firstName}
                    value={newClientData.firstName}
                    onChange={value =>
                        setNewClientData({ ...newClientData, firstName: value })
                    }
                />

                <TextInput
                    id="lastName"
                    label="Last Name"
                    inlineEditable={true}
                    value={newClientData.lastName}
                    onChange={value =>
                        setNewClientData({ ...newClientData, lastName: value })
                    }
                />
            </div>

            <div className="mb-4 mt-4">
                <TextInput
                    label="Email"
                    id="email"
                    inlineEditable={true}
                    value={newClientData.email}
                    onChange={value =>
                        setNewClientData({ ...newClientData, email: value })
                    }
                />
            </div>
            <div className="mb-4">
                <TextInput
                    label="Phone"
                    id="phone"
                    inlineEditable={true}
                    value={newClientData.phone}
                    onChange={value =>
                        setNewClientData({ ...newClientData, phone: value })
                    }
                />
            </div>
        </div>
    );
};

export default ClientEditForm;
